import { createContext, PropsWithChildren, useContext } from "react";
import { SubscriptionService } from "../services/SubscriptionService";
import { ISubscriptionService } from "../services/ISubscriptionService";
import { ExistingSubscription, Subscription } from "../model/model";

interface SubscriptionContextType {
  resolveSubsription: (marketplaceToken: string, accessToken: string) => Promise<Subscription>;
  activateSubscription: (
    tenantId: string,
    subscriptionId: string,
    planId: string,
    isTrial: boolean,
    maxUsersAllowed: number,
    accessToken: string
  ) => Promise<void>;
  getExistingSubscription: (tenantId: string, accessToken: string) => Promise<ExistingSubscription>;
  removeUser: (subscriptionId: string, tenantId: string, userId: string, accessToken: string) => Promise<void>;
}

const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

const useSubscription = (): SubscriptionContextType => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription was used outside of SubscriptionProvider');
  }
  return context;
}

interface SubscriptionProviderProps {
  queryString?: URLSearchParams
}

const SubscriptionProvider: React.FC<PropsWithChildren & SubscriptionProviderProps> = ({ children, queryString }) => {
  const service: ISubscriptionService = new SubscriptionService();  

  const context: SubscriptionContextType = {
    activateSubscription: async (t, s, p, i, m, a) => await service.activateSubscription(t, s, p, i, m, a),
    resolveSubsription: async (m, a) => await service.resolveSubscription(m, a),
    getExistingSubscription: async (t, a) => await service.getExistingSubscription(t, a),
    removeUser: async (s, t, u, a) => await service.removeUser(s, t, u, a)
  }

  return (
    <SubscriptionContext.Provider value={context}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export {
  SubscriptionProvider,
  useSubscription
}